<template>
    <div class="mt-2">
        <MultiselectInput
            :multiple="true"
            :placeholder="translate('bundle.select_bundles')"
            :options="bundleOptionsList"
            :model-value="bundlesToOptions(bundles)"
            @update:model-value="bundles = optionsToBundles($event)"
        />
        <p v-if="required && bundles.length === 0" class="help is-danger">
            {{ translate("bundle.select_bundles") }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import MultiselectInput from "./MultiselectInput.vue";
    import { translate } from "./translations";
    import { Bundle, bundleOptions, bundlesToOptions, optionsToBundles } from "./consts";

    withDefaults(defineProps<{ required?: boolean }>(), { required: true });
    const bundles = defineModel<Bundle[]>({ required: true });

    const bundleOptionsList = computed(() => bundleOptions());
</script>

<style scoped></style>
